import { BrandKitAsset } from "pages/media/types/";
import { useEffect } from "react";
import { Flex } from "antd";
import { usePublicMediaAssets, useTranslate } from "#src/hooks";
import { FontPurpose, FontPurposes } from "../../types";
import { PreviewTitle } from "./PreviewTitle";
import { FontItemCard } from "./FontItemCard";

export const FontsCard = ({
  fonts,
  setDefaultFonts,
  handleFontSelect,
  updateFontStateOptimistically,
}: {
  fonts: BrandKitAsset[];
  setDefaultFonts: (removedAssetId?: string) => Promise<void>;
  handleFontSelect: (purpose: FontPurpose, fontId: string) => void;
  updateFontStateOptimistically: (
    purpose: string,
    update: { asset_id: string; description?: string; path?: string } | null
  ) => void;
}) => {
  const t = useTranslate();
  const { defaultPublicFont, getPublicFontById } = usePublicMediaAssets();

  const handleFontSelectChange =
    (item: FontPurpose) => (_value: string, option: string) => {
      handleFontSelect(item, option);
      const updatedFont = getPublicFontById(option);
      if (updatedFont) {
        updateFontStateOptimistically(item, { asset_id: option, ...updatedFont });
      }
    };

  useEffect(() => {
    if (!defaultPublicFont) return;
    const run = async () => {
      try {
        await setDefaultFonts();
      } catch (error) {
        console.error("Failed to set default fonts:", error);
      }
    };
    void run();
  }, [defaultPublicFont, setDefaultFonts]);

  const findCurrentFont = (item: FontPurpose) =>
    fonts.find((font) => font.purpose === item);

  const fontItem = (
    item: FontPurpose,
    currentFont: BrandKitAsset | undefined
  ) => {
    return currentFont ? (
      <FontItemCard
        key={item}
        item={item}
        currentFont={currentFont}
        onFontSelectChange={handleFontSelectChange(item)}
      />
    ) : null;
  };

  return (
    <Flex vertical gap={20}>
      <PreviewTitle title={t("media.brandkit.edit.typography")} />
      <Flex vertical gap={24}>
        {FontPurposes.map((item) => fontItem(item, findCurrentFont(item)))}
      </Flex>
    </Flex>
  );
};
